const initialState = {
    conversations: [],
    conversations_count: 0,
    isReadingConversations: false,
    isUpdatingConversation: false,
    
    messages: [],
    messages_count: 0,
    message: {},
    isReadingMessages: false,
    
    filteredMessages: [],
    filtered_messages_count: 0,
    
    recipientPhones: [],
    isReadingRecipientPhones: false,

    textPanelUserOptions: [],
    filteredMessagesForTextPanel: [],
    filtered_messages_count_for_text_panel: 0,
    isReadingMessagesForTextPanel: false,

    textOfficeViewUserOptions: [],
    filteredMessagesForTextOfficeView: [],
    filtered_messages_count_for_text_office_view: 0,
    isReadingMessagesForTextOfficeView: false,

    textHistoryUserOptions: [],
    filteredMessagesForTextHistory: [],
    filtered_messages_count_for_text_history: 0,
    isReadingMessagesForTextHistory: false,

    textHistoryConversations: [],
    textHistoryConversations_count: 0,
    isReadingTextHistoryConversations: false,

    textPanelConversations: [],
    textPanelConversations_count: 0,
    isReadingTextPanelConversations: false,

    officeViewTextRecipientPhones: [],
    isReadingOfficeViewTextRecipientPhones: false,
    isSendingText: false,

    textPanelQuery: { page: 1 },
    textPanelConversationBeingViewed: null,
    textTabConversationBeingViewed: null,
    textHistoryConversationBeingViewed: null,

    isReadingContactPhones: false,
    contactPhones: [],
    isReadingUnsubscribedPhones: false,
    unsubscribedPhones: []
}

export default initialState;
